import React from 'react';
import '../styles/components/Footer.css';

interface FooterProps {
  companyName: string;
  creatorName: string;
  creatorEmail: string;
}

const Footer: React.FC<FooterProps> = ({ companyName, creatorName, creatorEmail }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} {companyName}
        </div>
        <div className="footer-creator">
          <span className="footer-cta">Made by <a target='_blank' rel="noreferrer" href="https://www.linkedin.com/in//" className="footer-email"> {creatorName}</a>   <a rel="noreferrer" href={`mailto:${creatorEmail}`} target='_blank' className="footer-email">
              ({creatorEmail})
            </a></span>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;